import React from "react";
import Button from "../Button";
import Roadmapimg from "../../assets/images/roadmapUpdateImg.svg";
const RoadMap = () => {
  return (
    <div id="roadSection" className="road-map  container   tw-pb-12">
      <div className="  sm:tw-pb-0 ">
        <div className="road-map-div">
          <h2 className="h-text-1"> Road Map</h2>
          {/* <p className="tw-text-white tw-leading-8">
            Our roadmap reflects our commitment to boost blockchains, innovation, DeFi growth, and sustainability, guiding us towards our vision of becoming a leader in the crypto mining industry and beyond.
          </p> */}
          <img src={Roadmapimg} className="  tw-mx-auto" />
        </div>
      </div>
    </div>
  );
};

const RoadMapPhase = ({ phase, title, items, para, className }) => (
  <div className="">
    <div className="row ">
      <div className={`col-md-11   tw-mx-auto `}>
        <div
          className={`md:tw-px-32 tw-px-0 tw-pt-0 tw-rounded-md ${className}`}>
          <button className="tw-py-2.5 tw-font-poppins tw-rounded-full  tw-bg-button-gradient tw-text-white  tw-w-40 ">
            {phase}
          </button>
          <h1 className="tw-text-black tw-font-semibold tw-text-[28px] tw-font-poppins tw-pt-4">
            {title}
          </h1>
          <p className={`tw-text-black tw-text-[20px]`}>{para}</p>
        </div>
      </div>
    </div>
  </div>
);

export default RoadMap;
